<template>
  <div class="upload">
    <div class="upload__header">
      <div class="upload__header__bread" @click="toSchedules">
        <i class="adx-ic_chevron_left"></i>
        <p>Schedules</p>
      </div>
      <div class="upload__header__title">
        <h2>Upload Management</h2>
      </div>
    </div>
    <div class="upload__content">
      <div class="upload__content__left">
        <div class="upload__content__left__filter">
          <div class="upload__content__left__filter__search">
            <i class="adx-ic_search"></i>
            <input type="text" placeholder="Search" class="search" v-model="searchBoxValue">
          </div>
          <div class="upload__content__left__filter__buttons">
            <div class="upload__content__left__filter__buttons__city">
              <adx-dropdown-list 
                :labelButton="selectedCity.label?selectedCity.label:'All City'" 
                :list="cityList"
                @selected="selectCity" />
            </div>
            <div class="upload__content__left__filter__buttons__orientation">
              <adx-dropdown-list 
                :labelButton="selectedOrientation.label?selectedOrientation.label:'All Orientation'" 
                :list="orientationList"
                @selected="selectOrientation" />
            </div>
          </div>
        </div>
        <adx-loading v-if="isLoading" />
        <div v-else class="upload__content__left__device">
          <div class="upload__content__left__device__header">
            <div class="upload__content__left__device__header__selection">
              <span :class="['selection-checkbox', selectAll ? 'checked' : '']" @click.stop="toggleCheckAllItem"><i class="icon-check"></i></span>
            </div>
            <span class="upload__content__left__device__header__title">DEVICES</span>
          </div>
          <div class="upload__content__left__device--bot">
            <div v-for="item in filteredDevices" :key="item.id" class="upload__content__left__device__item">
              <div class="upload__content__left__device__item__selection">
                <span :class="['selection-checkbox', selectedDevices.includes(item.id)
                ? 'checked' : '']"
                @click="selectDevice(item)"><i class="icon-check"></i></span>
              </div>
              <div class="upload__content__left__device__item__photo">
                <img v-if="item.orientation != 'Landscape'" class="portrait" :src="`/img/notfound/tv_portrait.png`" alt="">
                <img v-else class="landscpae" :src="`/img/notfound/tv_land.png`" alt="">
              </div>
              <div class="upload__content__left__device__item__desc">
                <span class="bold">{{item.location_name}}</span>
                <span class="bold">{{item.city_name}}</span>
                <span class="light">{{item.placement}}</span>
              </div>
            </div>
          </div>
          
        </div> 
      </div>
      <div class="upload__content__right">
        <div class="upload__content__right__create">
          <div class="calendar">
            <label class="small-font">Period of campaign</label>
            <v-date-picker
              v-model='startDate'
              :min-date='new Date()'
              :max-date='endDate'
              class='date-input'
              :theme-styles='themeStyles'
              :popoverAlign="'bottom'"
              :popoverVisibility="'focus'">
              <input
                class="calendar-start"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                disabled
                :value='inputValue'
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
            <i class="adx-ic_arrow_right"></i>
            <v-date-picker
              v-model='endDate'
              :min-date='startDate > new Date() ? startDate : new Date()'
              :popoverVisibility="'focus'"
              :popoverAlign="'bottom'"
              :theme-styles='themeStyles'
              class='date-input align-left'>
              <input
                class="calendar-start"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                disabled
                :value='inputValue'
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
          <div class="upload__content__right__create__duration">
            <adx-select-dropdown :label="`Ads Duration`" :value.sync="selectedDuration" 
            :options="user.groups.includes('grazilla') ? adminDuration : hostDuration" />
          </div>
          <div v-if="user.groups.includes('grazilla')" class="upload__content__right__create__type">
            <adx-select-dropdown :label="`Ownership Type`" :value.sync="ownershipType" 
            :options="ownershipTypeList" />
          </div>
          <div class="upload__content__right__create__media">
            <div class="upload__content__right__create__media--title">Insert Media</div>
            <p v-if="selectedDevices.length == 0">Please select any device</p>
            <template v-else>
              <div v-if="displayContents.includes('Landscape')" class="upload__content__right__create__media--landscape">
                <adx-input :label="`Landscape`" :value="selectedContent.landscape.title" :disabled="true" :button="`Choose File`" @buttonClicked="chooseMedia('landscape')"/>
              </div>
              <div v-if="displayContents.includes('Portrait')"  class="upload__content__right__create__media--portrait">
                <adx-input :label="`Portrait`" :value="selectedContent.portrait.title" :disabled="true" :button="`Choose File`" @buttonClicked="chooseMedia('portrait')"/>
              </div>
              <div v-if="displayContents.includes('Reverse Portrait')"  class="upload__content__right__create__media--portrait">
                <adx-input :label="`Reverse Portrait`" :value="selectedContent.reverse.title" :disabled="true" :button="`Choose File`" @buttonClicked="chooseMedia('portrait')"/>
              </div>
              <!-- <adx-input :label="`Square`" :value="content" :disabled="true" :button="`Choose File`" @buttonClicked="toggleEmail"/> -->
            </template>
          </div>
        </div>
        <div class="upload__content__right__buttons">
          <button class="btn-block primary" :class="isSaveLoading ? 'load' : ''" 
          @click="newSchedules" :disabled="validation" >
            Save & Publish 
            <div class="loading-wrap"> <adx-loading-white v-if="isSaveLoading" /> </div>
          </button>
        </div>
      </div>
    </div>
    <modal
      v-if="mediaModal"
      type="large"
      title="Choose Media File"
      @modal-close="closeMediaModal"
    >
      <div slot="content" class="media_editor">
        <div class="media_editor__menu">
          <span :class="['medialib', modalMediaTab == 'media' ? 'active' : '']" @click.stop="changeMediaTab('media')" class="subhead">Media Library</span>
          <span :class="['localfile', modalMediaTab == 'localfile' ? 'active' : '']" @click.stop="changeMediaTab('localfile')" class="subhead">Local File</span>
        </div>
        <div class="media_editor__content">
          <adx-media v-if="modalMediaTab == 'media'" :is-modal="true" @selected="setMedia"
          :orientation="orientationOnModal"  />
          <adx-upload v-if="modalMediaTab == 'localfile'" @done="changeMediaTab('media')" :orientation="orientationOnModal" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ListDropdown from '@/components/Dropdown/ListDropdown'
import SelectDropdown from '@/components/Form/SelectDropdown'
import Input from '@/components/Form/Input'
import Loading from '@/components/Loading/Primary'
import LoadingWhite from '@/components/Loading/Secondary-white'
import MediaLibrary from '@/views/Media'
import Upload from '@/views/Upload'
import Modal from '@/components/Modal'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import draggable from 'vuedraggable'
import moment from 'moment';
import calendar from 'v-calendar'
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'adx-schedules-upload',
  components: {
    'adx-dropdown-list': ListDropdown,
    'adx-select-dropdown': SelectDropdown,
    'adx-input': Input,
    'adx-loading': Loading,
    'adx-loading-white': LoadingWhite,
    'adx-media': MediaLibrary,
    'adx-upload': Upload,
    'v-calendar': calendar,
    Modal,
    draggable
  },
  props: {

  },
  data() {
    return {

      isLoading: false,
      isSaveLoading: false,
      searchBoxValue: '',
      selectAll: false,
      selectedCity: 
        {
          'id': 0,
          'label': 'All City',
          'value': ''
        },
      cityList: [
        {
          'id': 0,
          'label': 'All City',
          'value': ''
        },
      ],
      selectedOrientation: 
        {
          id: 0,
          label: 'All Orientation',
          value: ''
        },
      orientationList: [
        {
          id: 0,
          label: 'All Orientation',
          value: ''
        },
        {
          id: 1,
          label: 'Landscape',
          value: 'Landscape'
        },
        {
          id: 2,
          label: 'Portrait',
          value: 'Portrait'
        },
        {
          id: 3,
          label: 'Reverse Portrait',
          value: 'Reverse Portrait'
        },
      ],
      selectedDevices: [],
      displayContents: [],
      devices: [],
      filteredDevices: [],
      startDate: new Date(),
      endDate:  new Date(
								(new Date).getFullYear(),
								(new Date).getMonth(),
								(new Date).getDate() + 2),
      singleDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
      formats: {
        title: 'MMMM YYYY',
        weekdays: 'W',
        navMonths: 'MMM',
        input: ['L', 'YYYY-MMM-DD', 'YYYY/MMM/DD'],
        dayPopover: 'L',
        data: ['L', 'YYYY-MMM-DD', 'YYYY/MMM/DD']
      },
      selectedDuration: 15,
      hostDuration: [
        {
          label: '10 Seconds',
          value: 10
        },
        {
          label: '15 Seconds',
          value: 15
        },
        {
          label: '30 Seconds',
          value: 30
        },
      ],
      adminDuration: [],
      ownershipType: "selfowned",
      ownershipTypeList: [
        {
          id: 1,
          label: "Self Owned",
          value: "selfowned"
        },
        {
          id: 2,
          label: "Sponsored",
          value: "sponsored"
        },
      ],
      orientationOnModal: '',
      selectedContent: {
        landscape: {
          title: ''
        },
        portrait: {
          title: ''
        },
        reverse: {
          title: ''
        },
      },
      mediaModal: false,
      modalMediaTab: 'media'
    }
  },
  computed: {
    validation () {
      if (
        this.startDate &&
        this.endDate &&
        this.selectedDevices.length > 0 &&
        this.selectedDuration
        ) {
          if ( (this.displayContents.includes('Landscape') && !this.selectedContent['landscape'].id) ||
          (this.displayContents.includes('Portrait') && !this.selectedContent['portrait'].id) ||
          (this.displayContents.includes('Reverse Portrait') && !this.selectedContent['portrait'].id) ) {
            return true
          }else{
            return false
          }
        }
      else {
        return true
      }
    },
    contentParam() {
      let contentListId = []
      if (this.displayContents.includes('Landscape') && this.selectedContent['landscape'].id) {
        contentListId.push(this.selectedContent['landscape'].id)
      }
      if (this.displayContents.includes('Portrait') && this.selectedContent['portrait'].id) {
        contentListId.push(this.selectedContent['portrait'].id)
      }
      if (this.displayContents.includes('Reverse Portrait') && this.selectedContent['portrait'].id) {
        contentListId.push(this.selectedContent['portrait'].id)
      }
      return contentListId
    },
    tomorrow() {
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow
    },
    ...mapGetters({
      user: 'account',
    })
  },
  watch: {
    searchBoxValue: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    },
    selectedOrientation: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    },
    selectedCity: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.filterDevice()
      }
    }
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {
    this.createAdminDuration()
    this.getDevices()
    this.getCities()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    createAdminDuration() {
      let i = 15
      for (let i = 15; i <= 300; i = i + 15) {
        this.adminDuration.push({
          label: i + 'Seconds',
          value: i
        })
      }
    }, 
    chooseMedia(orientation) {
      this.orientationOnModal = orientation
      this.openMediaModal()
    },
    openMediaModal() {
      this.mediaModal = true
    },
    closeMediaModal() {
      this.mediaModal = false
    },
    setMedia(item, remove=false) {
      this.selectedContent[this.orientationOnModal] = item
      this.closeMediaModal()
    },
    changeMediaTab(selected) {
      this.modalMediaTab = selected
    },
    filterDevice() {
      let arrays = this.devices
      if (this.selectedCity.value) {
        arrays = arrays.filter(device => {
          return device.city_name == this.selectedCity.value
        })
      }
      if (this.selectedOrientation.value) {
        arrays = arrays.filter(device => {
          return device.orientation == this.selectedOrientation.value
        })
      }
      if(this.searchBoxValue) {
        arrays = arrays.filter(device => {
          let searchName = device.location_name.toLowerCase()
          let searchValue = this.searchBoxValue.toLowerCase()
          if (searchName.includes(searchValue)) return device
        })
      }
      this.filteredDevices = arrays
    },
    toSchedules() {
      this.$router.push({name:'hostschedules'})
    },
    selectCity(item){
      this.selectedCity = item
    },
    selectOrientation(item){
      this.selectedOrientation = item
    },
    selectDevice(item) {
      if(this.selectedDevices.includes(item.id)){
        let index = this.selectedDevices.indexOf(item.id);
        if (index > -1) {
          this.selectedDevices.splice(index, 1);
        }
        let indexContent = this.displayContents.indexOf(item.orientation);
        if (indexContent > -1) {
          this.displayContents.splice(indexContent, 1);
        }
        if(this.selectAll) this.selectAll = false
      } else {
        this.selectedDevices.push(item.id)
        this.displayContents.push(item.orientation)
        if(this.devices.length == this.selectedDevices.length) this.selectAll = true
      }
    },
    getDevices(){
      (async () => {
        this.isLoading = true
        let params = {
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.dashboardHostDevices, { needToken: true, params })
        this.devices = data
        this.filteredDevices = data
        this.isLoading = false
      })();
    },
    getCities(){
      (async () => {
        this.isLoading = true
        let params = {}
        const { data } = await api.get(apiV2.dashboardHostCities, { needToken: true, params })
        data.map(city => {
          this.cityList.push(
            {
              'id': city.id,
              'label': city.name,
              'value': city.name
            }
          )
        })
        this.isLoading = false
      })();
    },
    toggleCheckAllItem() {
      if (this.selectAll) {
        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    selectAllItem() {
      this.selectAll = true
      this.selectedDevices = this.filteredDevices.map(value => {return value.id})
      this.displayContents = this.filteredDevices.map(value => {return value.orientation})
    },
    unselectAllItem() {
      this.selectedDevices = []
      this.displayContents = []
      this.selectAll = false
    },
    newSchedules(){
      (async () => {
        this.isSaveLoading = true
        let data = {
          "duration": this.selectedDuration,
          "devices": this.selectedDevices,
          "contents": this.contentParam,
          "ownership_type": this.ownershipType,
          "end": moment(this.endDate).format('YYYY-MM-DD'),
          "start": moment(this.startDate).format('YYYY-MM-DD'),
        }
        const response = await api.post(apiV2.dashboardHostSchedulesCreate, data, { needToken: true })
        if (response.status == 201) {
          this.selectedContent = {
            landscape: {
              title: ''
            },
            portrait: {
              title: ''
            },
            reverse: {
              title: ''
            },
          }
          this.$notify({
            group: 'saved',
            title: 'Schedule created',
            text: 'Schedule successfully created',
            type: 'success'
          });
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'danger'
          });
        }
        this.isSaveLoading = false
        this.selectedDevices = []
        this.displayContents = []
      })();
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang="scss">
  .upload__content__left__filter__buttons__orientation,
  .upload__content__left__filter__buttons__city{
    .dropdown .dropdown__menu {
      min-width: 160px;
    }
  }
</style>
